import { type IHttpApi } from '@cian/http-api';
import { type ILogger } from '@cian/logger';
import { type IUIRuntime } from '@cian/mf-registry/browser';
import { type IMicrofrontendManifest, type IRegistry } from '@cian/mf-registry/shared';

import {
  type IGetSaveSearchMicrofrontendRequest,
  type TGetSaveSearchMicrofrontendResponse,
  fetchGetSaveSearchMicrofrontend,
} from '@/repositories/manually-added/shared/save-search-frontend/v1/get-save-search-microfrontend';

export type IFetchSaveSearchParameters = IGetSaveSearchMicrofrontendRequest;

export type TGetSaveSearchMicrofrontendResult = {
  manifest: IMicrofrontendManifest;
} | null;

interface IContext {
  httpApi: IHttpApi;
  microfrontendsRegistry: IRegistry;
  logger: ILogger;
}

const MICROFRONTEND_NAME = 'save-search-frontend';

let saveSearchManifest: IMicrofrontendManifest | null = null;

export async function getSaveSearchMicrofrontend(
  context: IContext,
  parameters: IFetchSaveSearchParameters = {},
): Promise<TGetSaveSearchMicrofrontendResult> {
  const { httpApi, logger, microfrontendsRegistry } = context;

  try {
    const registryMicrofront = !!microfrontendsRegistry.microfrontend(MICROFRONTEND_NAME);

    if (registryMicrofront && saveSearchManifest) {
      return {
        manifest: saveSearchManifest,
      };
    }

    const saveSearchData: TGetSaveSearchMicrofrontendResponse = await fetchGetSaveSearchMicrofrontend({
      httpApi,
      parameters,
    });

    const image = microfrontendsRegistry.register(saveSearchData.response.manifest);

    saveSearchManifest = saveSearchData.response.manifest;

    /* istanbul ignore next */
    if (typeof window !== 'undefined') {
      const runtime = image.runtimeStrict<IUIRuntime>(saveSearchData.response.manifest.runtimeName);
      await runtime.ensure();
    }

    return {
      manifest: saveSearchManifest,
    };
  } catch (ex) {
    logger.error(ex, { domain: 'shared.services.getSaveSearchMicrofrontend' });

    return null;
  }
}
